import { render, staticRenderFns } from "./resourceUpload.vue?vue&type=template&id=1c197cbf&scoped=true&"
import script from "./resourceUpload.vue?vue&type=script&lang=ts&"
export * from "./resourceUpload.vue?vue&type=script&lang=ts&"
import style0 from "./resourceUpload.vue?vue&type=style&index=0&id=1c197cbf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c197cbf",
  null
  
)

export default component.exports